






import { Component, Vue } from 'vue-property-decorator'
import SystemSetting from '@/components/setting/SystemSetting.vue'

@Component({
  components: {
    SystemSetting
  }
})

export default class Setting extends Vue {}
